define('shared/initializer/form/adapters/mixins/CardinalTerms',[
  'Promise',
  'shared/util/path/ResolverFactory',
  'shared/lib/cookie',
  'shared/util/cardinalAjax',
  'shared/util/redirectionSignal'
], function(
  Promise,
  PathResolverFactory,
  cookie,
  cardinalAjax,
  RedirectionLib
) {

  function Ctor() {}

  Ctor.prototype.doSubmit = function() {
    var me = this;
    var $form = me.$form;
    var $toc = me.items.toc.$el.filter(':checked');
    if ($toc.length == 0) {
      return false;
    }

    var sfid = cookie.get('sfid');
    var $OnSuccessUrl = cookie.get('continue_uri');

    return Promise.resolve()
      .then(function() {
        return cardinalAjax('/terms/web/' + sfid, 'GET');
      })
      .then(function(data) {
        if (!data) {
          throw new Error('No response from server');
        }

        if (!data.code) {
          if (data.status) {
            throw new Error(data.status);
          } else {
            throw new Error('Unknown response from server');
          }
        } else {

          switch (data.code) {
            case 'ACCEPTED':
              throw new RedirectionLib.RedirectionSignal({
                url: $OnSuccessUrl
              });
            default:
              throw new Error('Unknown response from server');
          }
        }
      })
      .then(function() {
        throw new Error('Unexpected execution path');
      }, function(err) {
        if (err instanceof RedirectionLib.RedirectionSignal) {
          return RedirectionLib.redirect(err);
        }

        if (!err.type) {
          err.type = 'generic';
        }
        err.fatal = false;
        return Promise.reject(err);
      });
  };

  return Ctor;
});

